var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMicLight = function SvgIconMicLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_mic_light_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_mic_light_svg__b)",
    fill: "#4BD667"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 14.5a3.219 3.219 0 0 1-3.215-3.215V7.1a3.216 3.216 0 0 1 6.43 0v4.185c0 1.77-1.44 3.215-3.215 3.215Zm0-9.515c-1.165 0-2.115.95-2.115 2.115v4.185c0 1.165.95 2.115 2.115 2.115 1.165 0 2.115-.95 2.115-2.115V7.1c0-1.165-.95-2.115-2.115-2.115Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.184a5.924 5.924 0 0 1-5.914-5.915h1.1A4.82 4.82 0 0 0 12 16.085a4.82 4.82 0 0 0 4.815-4.814h1.1A5.924 5.924 0 0 1 12 17.184ZM15.41 18.515H8.59v1.1h6.82v-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.55 16.635h-1.1v2.93h1.1v-2.93Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_mic_light_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_mic_light_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconMicLight;